import { useEffect, useState } from 'react';
import * as Sentry from '@sentry/browser';
import axios from '../../helpers/axios';
import { shd } from '@shd/jslib/models';

const useTeam = (teamId: string) => {
  const [team, setTeam] = useState<shd.Team>();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!teamId) {
      return;
    }
    setLoading(true);
    axios
      .get(`/api/team/${teamId}`)
      .then((response) => {
        setTeam(response.data.info);
        setError(null);
      })
      .catch((respError) => {
        Sentry.captureException(respError);
        setError(respError);
        setTeam(undefined);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [teamId]);

  return { team, error, loading };
};

const useTeamLiveAssets = (teamId: string) => {
  const [liveAssets, setLiveAssets] = useState<shd.LiveAsset[]>([]);
  useEffect(() => {
    axios
      .get(`/api/team/${teamId}/live_assets`)
      .then((response) => {
        setLiveAssets(response.data.liveAssets);
      })
      .catch((respError) => {
        Sentry.captureException(respError);
      });
  }, [teamId]);

  return liveAssets;
};

const useTeamByIdOrHandle = (teamId: string) => {
  const [team, setTeam] = useState<shd.Team>();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!teamId) {
      return;
    }
    setLoading(true);
    if (teamId.includes('TmSh01-')) {
      axios
        .get(`/api/team/${teamId}`)
        .then((response) => {
          setTeam(response.data.info);
          window.history.pushState(
            '',
            '',
            `/live/${response.data.info.nameHandle}`
          );
          setError(null);
        })
        .catch((respError) => {
          Sentry.captureException(respError);
          setError(respError);
          setTeam(undefined);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      axios
        .get(`/api/team_handle/${teamId}`)
        .then((response) => {
          return response.data;
        })
        .then((response) => {
          return axios.get(`/api/team/${response}`);
        })
        .then((response) => {
          setTeam(response.data.info);
          setError(null);
        })
        .catch((respError) => {
          Sentry.captureException(respError);
          setError(respError);
          setTeam(undefined);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [teamId]);

  return { team, error, loading };
};

export { useTeam, useTeamLiveAssets, useTeamByIdOrHandle };
